import { useState } from "react";
import { Tabs } from "antd";
import CurrencyPage from "./currency";
import NominalCodePage from "./nominal-code";

const MasterDataPage: React.FC = () => {
  const defaultTabKey = "1";
  const [activeKey, setActiveKey] = useState(defaultTabKey);

  const onChange = (newActiveKey: string) => {
    setActiveKey(newActiveKey);
  };

  const isDefaultTabKey = () => {
    return activeKey === defaultTabKey;
  };

  const initialItems = [
    {
      label: "Currency",
      children: <CurrencyPage />,
      key: defaultTabKey,
    },
    {
      label: "Nominal codes",
      children: <NominalCodePage />,
      key: "2",
    },
  ];

  return (
    <div className="page-master-data">
      <h2 className="title-page">Master Data</h2>
      <Tabs onChange={onChange} activeKey={activeKey} items={initialItems} destroyOnHidden />
    </div>
  );
};

export default MasterDataPage;
